import { validateInputNumberWithZero, validateInputString } from 'validation/validation';

export const errorModel = ({
    data, showYearlyPayments, isThreeB, is3aPremiumProductGroupSelector,
}) => ({
    nameOfPensionScheme: !isThreeB ? validateInputString(data.nameOfPensionScheme) : null,
    yearlyPayment: showYearlyPayments && !is3aPremiumProductGroupSelector ? validateInputNumberWithZero(data.yearlyPayment) : null,
    transferValue: (showYearlyPayments || isThreeB) ? null : validateInputNumberWithZero(data.transferValue),
});
